var SharedAjaxErrorView, SupportV2StepOneView, SupportVerticalCurrentOrderView, SupportVerticalSelectDifferentOrderMenuView, SupportVerticalStepOneView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SharedAjaxErrorView = require('../../../../shared/frontend/views/ajax_error_view');

SupportVerticalCurrentOrderView = require('../order_related/vertical_current_order_view');

SupportVerticalSelectDifferentOrderMenuView = require('../order_related/vertical_select_different_order_menu_view');

SupportV2StepOneView = require('./v2_view');

SupportVerticalStepOneView = (function(superClass) {
  extend(SupportVerticalStepOneView, superClass);

  function SupportVerticalStepOneView() {
    return SupportVerticalStepOneView.__super__.constructor.apply(this, arguments);
  }

  SupportVerticalStepOneView.prototype.className = 'v2 step-one vertical';

  SupportVerticalStepOneView.prototype.initialize = function() {
    SupportV2StepOneView.prototype.initialize.apply(this, arguments);
    return this.errorView = new SharedAjaxErrorView();
  };

  SupportVerticalStepOneView.prototype.render = function(params) {
    return SupportV2StepOneView.prototype.render.call(this, params);
  };

  SupportVerticalStepOneView.prototype.loadOrderErrorCallback = function() {
    this.errorView.render({
      container: this.$el,
      errorHtmlText: I18n.t("js.modules.support.order_listing_error")
    });
    return this.styleErrorView();
  };

  SupportVerticalStepOneView.prototype.loadOrderDetailsErrorCallback = function() {
    var $errorMessage;
    this.renderOrderListing();
    $errorMessage = $("<div></div>");
    this.errorView.render({
      container: $errorMessage,
      errorHtmlText: I18n.t("js.modules.support.order_details_error")
    });
    $(".help-wizard-content", this.$el).prepend($errorMessage);
    return this.styleErrorView();
  };

  SupportVerticalStepOneView.prototype.noOrdersView = function() {
    this.errorView.render({
      container: this.$el,
      errorHtmlText: I18n.t("js.modules.support.no_order_message")
    });
    return this.styleErrorView();
  };

  SupportVerticalStepOneView.prototype.styleErrorView = function() {
    return $(".page-error", this.$el).removeClass("text-center").addClass("notification");
  };

  SupportVerticalStepOneView.prototype.renderProgressBar = function(contentWrapper) {};

  SupportVerticalStepOneView.prototype.renderLegacyOrderBanner = function(contentWrapper) {};

  SupportVerticalStepOneView.prototype.createSubViews = function() {
    this.selectDifferentOrderMenu = new SupportVerticalSelectDifferentOrderMenuView();
    return this.currentOrderView = new SupportVerticalCurrentOrderView();
  };

  return SupportVerticalStepOneView;

})(SupportV2StepOneView);

module.exports = SupportVerticalStepOneView;

//# sourceMappingURL=data:application/json;base64,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
